//
// import './bootstrap';
// import { createApp } from 'vue';
// import VueAxios from 'vue-axios'
// import router from './router/router'
// import ExampleComponent from './components/ExampleComponent.vue';
// import Login from './components/Login.vue';
// import Dashboard from './components/Dashboard.vue';
// import Doctor from './components/users/Doctor.vue';
// import Username from './components/Username.vue';
// import DoctorIndex from './components/users/DoctorIndex.vue';
// import PatientIndex from './components/users/PatientIndex.vue';
// import Patient from './components/users/Patient.vue';
// import HospitalIndex from "./components/users/HospitalIndex.vue";
// import UserTypeIndex from "./components/usertype/Index.vue";
// import AdminIndex from "./components/AdminIndex.vue";
// import Designation from "./components/Designation.vue"
// import TeamMember from "./components/TeamMember.vue"
// import CurrencyIndex from "./components/CurrencyIndex.vue";
// import BranchesIndex from "./components/BranchesIndex.vue";
// import CommunityCareProvider from "./components/users/CommunityCareProvider.vue";
// import CorporatePatient from "./components/users/CorporatePatient.vue"
// import VulgarWord from "./components/VulgarWord.vue"
// import Subscription from "./components/Subscription.vue"
//
// import axios from 'axios';
// import 'bootstrap';
// import store from './store'
// import DataTable from "datatables.net";
// import Hmo from './components/Hmo.vue'
// import Product from './components/Product.vue'
// import DiagnosticCenter from "./components/users/DiagnosticCenter.vue";
// import CorporateAdmin from "./components/users/CorporateAdmin.vue";
// import Appointment from "./components/Appointment.vue";
// import PostAndComment from "./components/PostAndComment.vue";
// import OrderItem from "./components/OrderItem.vue";
// import DoctorReport from "./components/reports/DoctorReport.vue";
// import Comments from "./components/Comments.vue";
// import Pharmacy from "./components/users/Pharmacy.vue";
//
//
// const app = createApp({});
// app.use(store)
// app.use(DataTable)
//
// app.config.globalProperties.$axios = axios;
// app.config.productionTip = false;
// app.use(VueAxios, axios)
// app.use(router)
//
// app.component('diagnostic-center', DiagnosticCenter)
// app.component('example-component', ExampleComponent);
// app.component('login', Login);
// app.component('corporate-admin', CorporateAdmin)
// app.component('dashboard', Dashboard);
// app.component('doctor-form', Doctor);
// app.component('username', Username);
// app.component('doctor-index', DoctorIndex);
// app.component( 'patient-index',PatientIndex);
// app.component( 'patient',Patient);
// app.component( 'hospital-index',HospitalIndex);
// app.component('usertype', UserTypeIndex)
// app.component('admin-index', AdminIndex)
// app.component('hmo', Hmo)
// app.component('product', Product)
// app.component( 'designation', Designation)
// app.component( 'team-member', TeamMember)
// app.component('currency-index', CurrencyIndex)
// app.component('branches-index', BranchesIndex)
// app.component('community-care-provider-index', CommunityCareProvider)
// app.component('corporate-patient-index', CorporatePatient)
// app.component('vulgar-index', VulgarWord)
// app.component('appointment-index', Appointment)
// app.component('subscription-index', Subscription)
// app.component('post-comment.index', PostAndComment)
// app.component('order-item.index', OrderItem)
// app.component('doctor-report-index', DoctorReport )
// app.component('comment', Comments)
// app.component('pharmacy-index', Pharmacy)
// app.mount('#app');


import Vue from 'vue'
import VueMeta from 'vue-meta'
import { InertiaProgress } from '@inertiajs/progress'
import VueSweetalert2 from 'vue-sweetalert2';
import VueGoodTablePlugin from 'vue-good-table';
import vSelect from 'vue-select'
import {Vuelidate} from 'vuelidate';
import DatePicker from 'vue2-datepicker'
import JsonCSV from 'vue-json-csv';

import 'sweetalert2/dist/sweetalert2.min.css';
import 'vue-select/dist/vue-select.css';
import 'vue-good-table/dist/vue-good-table.css'
import 'vue2-datepicker/index.css';
import {createInertiaApp} from "@inertiajs/inertia-vue";


Vue.mixin({ methods: { route: window.route } })
Vue.use(VueMeta)
Vue.use(VueSweetalert2);
Vue.use(DatePicker);
Vue.use(Vuelidate);
Vue.use(VueGoodTablePlugin);
Vue.component('downloadCsv', JsonCSV);
vSelect.props.components.default = () => ({
    Deselect: {
        render: createElement => createElement('span', 'x'),
    },
    // OpenIndicator: {
    //     render: createElement => createElement('span', '🔽'),
    // },
});
Vue.component('v-select', vSelect)

window.axios = require('axios');

InertiaProgress.init()


createInertiaApp({
    resolve: name => require(`./Pages/${name}`),
    setup({el, app, props}) {
        new Vue({
            metaInfo: {
                titleTemplate: title => (title ? `${title} | Wazima` : 'Wazima'),
            },
            render: h => h(app, props),
        }).$mount(el)
    },
});

